'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unavailableContext = exports.unavailable = exports.detailsTime = exports.detailsLabel = exports.detailsCol = exports.detailsRow = exports.details = exports.teamDetails = exports.teamName = exports.team = exports.color = exports.shiftCard = undefined;

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

var _flex = require('../styles/flex');

var _flex2 = _interopRequireDefault(_flex);

var _helpers = require('../styles/helpers');

var _media = require('../styles/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shiftCard = exports.shiftCard = (0, _glamorReact.css)((0, _flex2.default)(), (0, _helpers.margin)('0.5rem'), (0, _colors.background)(_colors.COLORS.WHITE), {
  width: '28rem',
  minHeight: '9rem',
  alignItems: 'stretch',
  borderRadius: '0.125rem',
  overflow: 'hidden',
  boxShadow: '0 0 1rem 0.125rem ' + _colors.COLORS.BLACK
}, (0, _media.phone)({
  width: '18rem',
  height: '5rem',
  minHeight: '5rem'
}));

var color = exports.color = (0, _glamorReact.css)((0, _media.phone)({ width: '10%' }), {
  width: '3rem'
});

var team = exports.team = (0, _glamorReact.css)((0, _flex2.default)({ grow: 4, direction: 'column' }), (0, _colors.background)(_colors.COLORS.WHITE), (0, _helpers.padding)('1rem'), (0, _media.phone)({ width: '35%' }));

var teamName = exports.teamName = (0, _glamorReact.css)((0, _helpers.margin)(0), (0, _helpers.font)('1.5rem'), (0, _colors.text)(_colors.COLORS.GREY), (0, _media.phone)((0, _helpers.font)('1rem')));

var teamDetails = exports.teamDetails = (0, _glamorReact.css)((0, _helpers.margin)(0), (0, _helpers.font)('initial', 'normal'), (0, _colors.text)(_colors.COLORS.GREY), (0, _media.phone)((0, _helpers.font)('0.9rem')));

var details = exports.details = (0, _glamorReact.css)((0, _flex2.default)({ grow: 6, direction: 'column' }), (0, _helpers.padding)('1rem'), { justifyContent: 'space-around' });

var detailsRow = exports.detailsRow = (0, _glamorReact.css)((0, _flex2.default)(), { alignItems: 'center' });

var detailsCol = exports.detailsCol = (0, _glamorReact.css)((0, _flex2.default)({ grow: 1 }));

var detailsLabel = exports.detailsLabel = (0, _glamorReact.css)((0, _helpers.margin)(0), (0, _helpers.font)('1.2rem', 'bold'), (0, _colors.text)(_colors.COLORS.GREY), (0, _media.phone)((0, _helpers.font)('1rem')));

var detailsTime = exports.detailsTime = (0, _glamorReact.css)((0, _helpers.margin)(0), (0, _helpers.font)('1.2rem'), (0, _colors.text)(_colors.COLORS.GREY), (0, _media.phone)((0, _helpers.font)('0.9rem')));

var unavailable = exports.unavailable = (0, _glamorReact.css)((0, _flex2.default)({ grow: 1, direction: 'column' }), {
  alignItems: 'center',
  justifyContent: 'center'
});

var unavailableContext = exports.unavailableContext = (0, _glamorReact.css)((0, _colors.text)(_colors.COLORS.OFF_WHITE), (0, _helpers.font)('1.5rem'), (0, _helpers.margin)('1rem', 0));


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/ShiftCard/styles.js
// module id = 1607
// module chunks = 0